'use client';

import React from 'react';

import styles from './dialog.module.scss';

export type DialogBodyProps = {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

export function DialogBody({ children, className, style }: DialogBodyProps) {
  return (
    <div className={`${styles.body} ${className || ''}`} style={style}>
      {children}
    </div>
  );
}
